/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Result of a live probe that Speakeasy can assume the identity the credential names.
 */
export type VerifyCredentialResult = {
  /**
   * Human-readable detail about the probe outcome, including the failure reason when it did not verify.
   */
  detail?: string | undefined;
  /**
   * The principal the credential resolves to — the impersonated service account.
   */
  principal?: string | undefined;
  /**
   * Whether Speakeasy could assume the credential's identity.
   */
  verified: boolean;
};

/** @internal */
export const VerifyCredentialResult$inboundSchema: z.ZodMiniType<
  VerifyCredentialResult,
  unknown
> = z.object({
  detail: z.optional(z.string()),
  principal: z.optional(z.string()),
  verified: z.boolean(),
});

export function verifyCredentialResultFromJSON(
  jsonString: string,
): SafeParseResult<VerifyCredentialResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => VerifyCredentialResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'VerifyCredentialResult' from JSON`,
  );
}
